import { createTheme } from "@mui/material/styles"
import { grey } from "@mui/material/colors"

import { itIT as coreItIT } from "@mui/material/locale"
import { itIT } from "@mui/x-data-grid"

import itLocale from "date-fns/locale/it"

import "./createPalette.d"

const defaultTheme = createTheme()
export const lightTheme = createTheme({
	typography: {
		fontFamily: "Poppins, sans-serif",
	},
	palette: {
		mode: "light",
		primary: {
			main: "#11347B",
		},
		secondary: {
			main: "#00A3E5",
		},
		neutral: defaultTheme.palette.augmentColor({
			color: {
				main: "#5B626B",
			},
			name: "neutral",
		}),
		success: {
			//main: "#2CAC97",
			main: "#0d6e00"
		},
		info: {
			main: "#599ACC",
		},
		warning: {
			main: "#F3B243",
		},
		error: {
			main: "#F15152",
		},
		text: {
			primary: "#5f666f",
		},
	},
	components: {
		MuiTextField: {
			defaultProps: {
				size: "small",
			},
		},
		MuiFormControl: {
			defaultProps: {
				size: "small",
			},
		},
		MuiButton: {
			styleOverrides: {
				containedSecondary: {
					color: "white",
					textTransform: "none",
					fontSize: "0.8rem",
				},
				containedNeutral: {
					color: "white",
					textTransform: "none",
					fontSize: "0.8rem",
				},
			},
			defaultProps: {
				size: "medium",
			},
		},
		MuiSelect: {
			styleOverrides: {
				multiple: {
					"& .MuiChip-root": {
						height: "unset",
						fontSize: "0.75em",
					},
				},
			},
		},
		MuiBadge: {
			styleOverrides: {
				badge: {
					fontSize: "0.6rem",
					minWidth: "20px",
					borderRadius: "5px",
					height: "15px",
				}
			}
		}
	},
}, itLocale, itIT, coreItIT)

export const darkTheme = createTheme(lightTheme, {
	palette: {
		mode: "dark",
		background: {
			paper: "#11347B",
		},
		primary: {
			main: "#11347B",
			contrastText: "#ffffff",
		},
		text: {
			primary: "#ffffff",
			secondary: grey[300],
		},
		action: {
			active: "#ffffff",
		}
	},
})
